import React, { Fragment, useState } from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Nav, MobileNav } from './../../elements/SharedElements';

const Navigation = () => {

    const [menu,setMenu] = useState(true);

    const toggleMenu = () => {

        setMenu(!menu);

    }

    return (
        <Fragment>
            <Nav>
                <div className="container">
                    <div className="logo">
                        <Link to="/"><img src="zapowerhouse-logo.jpeg" alt="ZaPowerHouse Logo" /></Link>
                    </div>
                    <ul>
                        <li><Link activeClassName="active" to="/">Home</Link></li>
                        <li><Link activeClassName="active" to="/about">About Us</Link></li>
                        <li><Link activeClassName="active" to="/projects">Our Projects</Link></li>
                        <li><Link activeClassName="active" to="/sponsors">Our Sponsors</Link></li>
                        <li><Link activeClassName="active" to="/contact">Contact Us</Link></li>
                    </ul>
                    <div className="donate">
                        <Link to="/donate" className="btn">Donate</Link>
                    </div>
                    {
                        (menu) ? <FontAwesomeIcon onClick={toggleMenu} icon={faBars} /> :  <FontAwesomeIcon onClick={toggleMenu} icon={faTimes} />
                    }
                </div>
            </Nav>
            {
                !menu && 
                <MobileNav>
                    <ul>
                        <li><Link activeClassName="active" to="/">Home</Link></li>
                        <li><Link activeClassName="active" to="/about">About Us</Link></li>
                        <li><Link activeClassName="active" to="/projects">Our Projects</Link></li>
                        <li><Link activeClassName="active" to="/sponsors">Our Sponsors</Link></li>
                        <li><Link activeClassName="active" to="/contact">Contact Us</Link></li>
                    </ul>
                    <div className="donate">
                        <Link to="/donate" className="btn">Donate</Link>
                    </div>  
                </MobileNav>
            }
        </Fragment>
    )
    

}
export default Navigation;